import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationCounterComponent } from './pagination-counter.component';

@NgModule({
	declarations: [],
	imports: [PaginationCounterComponent],
	exports: [PaginationCounterComponent],
})
export class PaginationCounterModule {}
